import styled from 'styled-components';

import placeApi from '@src/services/api/place';
import { RequestBookingListType } from '@src/types/booking';
import { useEffect, useMemo, useRef, useState } from 'react';
import RequestListTable from './table';
import Input from '@src/components/ui/atoms/input';
import Button from '@src/components/ui/atoms/button';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { Tabs } from '@mui/material';
import RequestCard from './card';

export const Container = styled.div``;

const CookieInputWarp = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-end;
  button {
    align-self: flex-end;
  }
`;

const CookieInputStatus = styled.div`
  margin-top: 10px;
  color: #6d6d6d;
`;

export const InfoWrap = styled.div`
  padding: 10px 0;
  display: flex;
  gap: 20px;
  > div {
    flex: 1;
  }
`;

const TAB_LIST = [
  {
    key: 'COOKIE',
    label: '쿠키 설정',
  },
  {
    label: '결제 대기',
    key: 'PAYMENT',
  },
  {
    label: '실패',
    key: 'FAIL',
  },
];

type TabType = (typeof TAB_LIST)[number]['key'];

interface TabPanelProps {
  children?: React.ReactNode;
  value: TabType;
  selected: TabType;
}

function TabPanel(props: TabPanelProps) {
  const { children, selected, value } = props;

  return (
    <div
      role="tabpanel"
      hidden={selected !== value}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
    >
      {value === selected && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TodayBookingRequestList() {
  const [requestList, setRequestList] = useState<RequestBookingListType[]>();
  const [tab, setTab] = useState<TabType>('COOKIE');
  const [cookie, setCookie] = useState('');
  const successBookingList = useMemo(() => {
    return requestList?.filter(request => {
      const response = request.response && JSON.parse(request.response);
      const result = response ? !response.errors : undefined;
      return result === true;
    });
  }, [requestList]);
  const failBookingList = useMemo(() => {
    return requestList?.filter(request => {
      const response = request.response && JSON.parse(request.response);
      const result = response ? !response.errors : undefined;
      return result === false;
    });
  }, [requestList]);
  async function getScheduleList() {
    const { data } = await placeApi.getTodayBookingRequestList();
    setRequestList(data.filter(({ id }) => id !== 178));
  }

  const handleSetCookie = async () => {
    if (!cookie) {
      return;
    }
    try {
      if (!requestList?.length) {
        return;
      }
      const { data } = await placeApi.setCookie(
        requestList.filter(({ id }) => id !== 178).map(({ id }) => id),
        cookie,
      );
      setRequestList(data);
      alert('쿠키 입력 완료');
    } catch (error) {
      alert(error);
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setTab(newValue);
  };

  useEffect(() => {
    getScheduleList();
  }, []);

  return (
    <Container>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={handleTabChange}>
          {TAB_LIST.map(tab => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      <TabPanel value="COOKIE" selected={tab}>
        <CookieInputWarp>
          <Input multiline onChange={setCookie} value={cookie} />
          <Button onClick={handleSetCookie}>Set cookie</Button>
        </CookieInputWarp>
        {requestList?.map(request => (
          <RequestCard key={request.id} request={request}>
            <CookieInputStatus>{request.cookie ? '쿠키 입력 완료' : '쿠키 입력 대기'}</CookieInputStatus>
          </RequestCard>
        ))}
      </TabPanel>
      <TabPanel value="PAYMENT" selected={tab}>
        {/* {JSON.parse(successBookingList)} */}
        {successBookingList?.map(request => {
          const response = request.response && JSON.parse(request.response);
          const url = response?.data?.submitBooking?.url?.pc;
          return (
            <a key={request.id} href={url} target="_blank" rel="noreferrer">
              <RequestCard key={request.id} request={request} />
            </a>
          );
        })}
      </TabPanel>
      <TabPanel value="FAIL" selected={tab}>
        {failBookingList?.map(request => <RequestCard key={request.id} request={request} />)}
      </TabPanel>
    </Container>
  );
}
